<template>
  <Layout>
    <router-view />
  </Layout>
  <Configuration />
  <Notification ref="notification" />
</template>

<script>
import '@/assets/fonts/inter/inter.css'
import '@/assets/icons/phosphor/styles.min.css'
import '@/assets/template/css/all.min.css'
import '@/assets/template/js/app'
import '@/assets/template/js/configuration'
import '@/assets/template/js/datatables'

import Layout from '@/views/layout/Layout.vue'
import Configuration from '@/components/commons/Configuration.vue'
import Notification from '@/components/commons/Notification.vue'

export default {
  name: 'App',

  components: {
    Layout,
    Configuration,
    Notification,
  },
}
</script>

<style>
label.form-check-label {
  cursor: pointer;
}

.badge-course-ethos {
  position: absolute;
  left: 2px;
  top: 5px;
  background-image: url('~@/assets/img/logo.svg');
  background-repeat: no-repeat;
  padding: 1.6rem;
}
</style>
